export const configuration = {
  SUB_API_URL: "https://api.101proxy.top",
  // SUB_API_URL: "http://localhost:8080",
};
